import {getCookie, getCookieName} from '../../common/utils/cookieUtils'
import {ApiService} from '../ApiService'
import {PagesInfo} from '../PagesInfo/type'
import {XpertKnowledgeDto} from '../XpertKnowledge/type'
import {HideXpertKnowledgeBufferBody, XpertKnowledgeBufferDto} from './type'

class XpertKnowledgeBufferServiceProvider extends ApiService {
  async getAllAdmin(): Promise<XpertKnowledgeBufferDto[]> {
    return this.get<XpertKnowledgeBufferDto[]>(`/xpert-knowledge-buffer/admin`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }
  async getAll(): Promise<PagesInfo<XpertKnowledgeDto>> {
    return this.get<PagesInfo<XpertKnowledgeDto>>(`/xpert-knowledge-buffer`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async hideBuffer(body: HideXpertKnowledgeBufferBody): Promise<void> {
    return this.post<void>(`/xpert-knowledge-buffer`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }
}

export const XpertKnowledgeBufferService = new XpertKnowledgeBufferServiceProvider()
